
// Shared guard for GLOBAL single-key keyboard shortcuts (originally written
// for Digitalisering's "L"/"Shift+L" label toggles - task: "Den eksisterende
// guard fra L/Shift+L skal genbruges/generaliseres" for the newer
// classification 1-4 shortcuts). A global shortcut must never fire while the
// user is typing into ANY editable control - not just a plain text field,
// but a number input (Radius, Diameter, Længde, Bredde, Pilhøjde, Kote,
// Fald…), a <select>, or a contenteditable element - so a value like "162"
// never gets its "1"/"2" intercepted as a classification toggle mid-type.
//
// Deliberately keyed off `document.activeElement`'s tag/property, NOT
// `event.stopPropagation()` in the input's own container: every geometry
// popup in this codebase (see VectorEditingMenu.js's createDialogOverlay())
// only stops propagation for Escape/Enter, not every keystroke - so a
// keydown while typing a number DOES still bubble all the way up to a
// window-level shortcut listener. Checking what currently has FOCUS (true
// for the whole time the user is typing, regardless of where in the bubble
// chain a listener sits) is what actually prevents the conflict, and works
// for any current or future popup without that popup needing to know
// anything about which shortcuts exist.
//
// No DOM dependency beyond the passed-in element - Level 1 (no-browser)
// unit testable with a plain {tagName, isContentEditable} stand-in, see
// keyboardGuard.test.js.
export function isEditableTarget(el){
	if(!el) return false;
	const tag = el.tagName;
	if(tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
	return !!el.isContentEditable;
}

// Convenience wrapper for the common case: is *whatever currently has focus
// in the document* an editable control right now. Callers that already have
// the element (e.g. from `document.activeElement` themselves) can call
// `isEditableTarget()` directly instead.
export function shouldIgnoreGlobalShortcut(doc = document){
	return isEditableTarget(doc.activeElement);
}
